module.exports = __webpack_public_path__ + "public/img/word.a58c5a21.png";